import React, { Suspense } from 'react';
import { Provider } from 'react-redux';
import { HashRouter as Router, Route, Switch } from 'react-router-dom';
import Loader from 'bharat-ui/web/Loader';
import { showPostPeUI, showTwelvePcUI, showZillionUi } from 'utils/Utils';

import store from 'store';
import LoaderNew from 'components/atoms/Loader';
import Home from 'containers/Home';
import JuspayMicroWebView from 'containers/JuspayMicroWebView';
import JuspayLandingPage from 'containers/JuspayLandingPage';
import JuspayBharatpeLandingPage from 'containers/JuspayBharatpeLandingPage';
import JuspayWebIntermediaryPage from 'containers/JuspayWebIntermediaryPage';
import JuspayWebLandingPage from 'containers/JuspayWebLandingPage';

const isShowTwelvePcUI = showTwelvePcUI();
const isShowPostPeUI = showPostPeUI();
const isShowZillionUi = showZillionUi();

//const Home = React.lazy(() => import('containers/Home'));
const PaymentView = React.lazy(() => import('containers/PaymentView'));
const upiPayment = React.lazy(() => import('../../src/components/atoms/UpiPayment'));
const CheckStatus = React.lazy(() => import('../containers/CheckStatus'));
const ThanksView = React.lazy(() => import('../containers/ThanksView'));
const FinalStatusView = React.lazy(() => import('../containers/FinalStatusView'));
const Routes: React.FC = () => (
	<Provider store={store}>
		<Suspense
			fallback={
				isShowPostPeUI ? (
					<div>Loading</div>
				) : isShowTwelvePcUI || isShowZillionUi ? (
					<LoaderNew loading loaderType={isShowTwelvePcUI ? '12pc' : 'zillion'} />
				) : (
					<Loader loading />
				)
			}>
			<Router basename={process.env.PUBLIC_URL}>
				<Switch>
					<Route exact path="/" component={Home} />
					<Route path={`/payment`} component={PaymentView} />
					<Route path={'/upi-pay'} component={upiPayment} />
					<Route path={'/check-status'} component={CheckStatus} />
					<Route path={`/thanks`} component={ThanksView} />
					<Route path="/juspay-micro-webview" component={JuspayMicroWebView} />
					<Route path="/juspay-landing/:pageSource" component={JuspayLandingPage} />
					<Route path="/juspay-bharatpe-landing" component={JuspayBharatpeLandingPage} />
					<Route path="/juspay-web-intermediary" component={JuspayWebIntermediaryPage} />
					<Route path="/juspay-web-landing" component={JuspayWebLandingPage} />
					<Route path="/final-payment-status" component={FinalStatusView} />
				</Switch>
			</Router>
		</Suspense>
	</Provider>
);

export default React.memo(Routes);
